import State from '../interfaces/states/State';

import { createSelector } from 'reselect';

const isLogined = createSelector(
  (state: State) => !!state.auth.token,
  (token): boolean => {
    return token;
  }
);

export default isLogined;
